var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconDoc(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.41.333H5.59C1.18.333.085 1.512.085 6.213V19.35c0 3.103 1.703 3.838 3.768 1.622l.012-.012c.957-1.015 2.415-.933 3.243.175l1.179 1.575c.945 1.248 2.473 1.248 3.418 0l1.178-1.575c.84-1.12 2.299-1.202 3.255-.175 2.077 2.217 3.769 1.482 3.769-1.622V6.213c.011-4.701-1.085-5.88-5.495-5.88zM5.078 12a1.17 1.17 0 0 1-1.166-1.166 1.17 1.17 0 0 1 1.166-1.167 1.17 1.17 0 0 1 1.167 1.167A1.17 1.17 0 0 1 5.077 12zm0-4.667a1.17 1.17 0 0 1-1.166-1.166A1.17 1.17 0 0 1 5.077 5a1.17 1.17 0 0 1 1.167 1.167 1.17 1.17 0 0 1-1.167 1.167zm9.859 4.376H8.519a.881.881 0 0 1-.875-.875c0-.479.397-.875.875-.875h6.417c.478 0 .875.396.875.875a.881.881 0 0 1-.875.875zm0-4.667H8.519a.881.881 0 0 1-.875-.875c0-.478.397-.875.875-.875h6.417c.478 0 .875.397.875.875a.881.881 0 0 1-.875.875z",
    fill: "#0044EB"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDoc);
export default __webpack_public_path__ + "static/media/icon_doc.e271fac7f50a03797333765184629026.svg";
export { ForwardRef as ReactComponent };